<template lang="html">
  <div class="cloud-photo-info">
    <div class="cloud-photo-steps-title pf-medium">拍摄流程</div>
    <div class="steps-section">
      <div v-for="(item, index) in steps" class="step-item">
        <div class="step-index-section">
          <img
            v-if="stepIndexImgIconIsNeeShow(item)"
            class="step-index-icon-img"
            src="../../assets/images/order/icon_cloud_photo_step.png"
            alt=""
          />
          <div v-else class="step-index" :class="stepIndexShowClass(item)">
            {{ index + 1 }}
          </div>
          <div
            class="step-stage-v-line"
            :class="stepIndexVLineShowClass(item)"
            v-if="steps.length - 1 != index"
          ></div>
        </div>
        <div class="step-info-section">
          <div class="step-title" :class="stepTitleShowClass(item)">
            {{ item.title }}
          </div>
          <div class="step-tips-line" :class="stepTipsShowClass(item)">
            <div
              v-if="step2NeedShowReservedDateTime(item, index)"
              class="step-2-take-photo-date-time"
            >
              到店时间：{{ takePhotoReserveDateTime }}
            </div>
            <div class="step-others-tips" v-else-if="stepTipsNeedShow(item)">
              {{ item.stepTips }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-action">
      <button
        class="btn-large"
        @click="toReserveDateTimeTakePhoto"
        v-if="needShowReserveDateTimeBtn"
      >
        预约拍摄
      </button>
      <button
        class="btn-large"
        @click="toModifyDateTimeTakePhoto"
        v-else-if="needShowModifyReserveDateTimeBtn"
      >
        修改预约
      </button>
      <button
        class="btn-large"
        @click="toMyAlbum"
        v-else-if="needShowMyAlbumBtn"
      >
        我的相册
      </button>
    </div>
  </div>
</template>

<script>
import { pushNrNs } from '@/plugins/jump'
import { CLOUD_PHOTO_STATE_ENUM } from '@/config'

export default {
  props: {
    order: {
      type: Object,
      default: {}
    }
  },
  inject: {
    myAlbumTrackParams: {
      default: null
    }
  },
  data() {
    return {
      currCloudPhotoState: 0,
      steps: [
        {
          stepIndex: 1,
          title: '下单成功'
        },
        {
          stepIndex: 2,
          title: '预约拍摄'
        },
        {
          stepIndex: 3,
          title: '现场拍摄',
          stageStatus: 0
        },
        {
          stepIndex: 4,
          title: '挑选精修照片',
          stepTips: '请在拍摄完成后7天内在“我的相册”中挑选精修照片'
        },
        {
          stepIndex: 5,
          title: '修图师修片',
          stepTips: '预计5个工作日内交付精修片'
        },
        {
          stepIndex: 6,
          title: '交付精修照片',
          stepTips: '请在“我的相册”中下载精修片'
        }
      ]
    }
  },
  created() {
    this.currCloudPhotoState = parseInt(this.order.cloudPhotoState) || 0
  },
  methods: {
    stepIndexImgIconIsNeeShow(stepItem) {
      return stepItem.stepIndex < this.currCloudPhotoState
    },
    stepIndexShowClass(stepItem) {
      let classStyle = ''
      if (stepItem.stepIndex < this.currCloudPhotoState) {
        classStyle = 'step-index-completed'
      } else if (stepItem.stepIndex == this.currCloudPhotoState) {
        classStyle = 'step-index-on-stage'
      } else {
        classStyle = 'step-index-not-start'
      }
      return classStyle
    },
    stepTitleShowClass(stepItem) {
      let classStyle = ''
      if (stepItem.stepIndex < this.currCloudPhotoState) {
        classStyle = 'step-title-completed'
      } else if (stepItem.stepIndex == this.currCloudPhotoState) {
        classStyle = 'step-title-on-stage'
      } else {
        classStyle = 'step-title-not-start'
      }

      return classStyle
    },
    stepIndexVLineShowClass(stepItem) {
      let classStyle = ''
      if (stepItem.stepIndex < this.currCloudPhotoState) {
        classStyle = 'step-index-vline-completed'
      } else if (stepItem.stepIndex == this.currCloudPhotoState) {
        classStyle = 'step-index-vline-on-stage'
      } else {
        classStyle = 'step-index-vline-not-start'
      }

      return classStyle
    },
    stepTipsNeedShow(stepItem) {
      return stepItem.stepIndex <= this.currCloudPhotoState && stepItem.stepTips
    },
    stepTipsShowClass(stepItem) {
      let classStyle = ''
      if (stepItem.stepIndex < this.currCloudPhotoState) {
        classStyle = 'step-tips-completed'
      } else if (stepItem.stepIndex == this.currCloudPhotoState) {
        classStyle = 'step-tips-on-stage'
      }

      return classStyle
    },
    step2NeedShowReservedDateTime(stepItem, index) {
      return (
        1 == index &&
        index <= this.currCloudPhotoState &&
        this.order.reserveRecord
      )
    },
    toReserveDateTimeTakePhoto() {
      this.$router.push({
        name: 'add-reserve',
        query: {
          orderId: this.order.orderId,
          businessId: this.order.businessId
        }
      })
    },
    toModifyDateTimeTakePhoto() {
      this.$router.push({
        name: 'add-reserve',
        query: {
          orderId: this.order.orderId,
          businessId: this.order.businessId,
          reserveId: this.order?.reserveRecord?.id || ''
        }
      })
    },
    toMyAlbum() {
      this.myAlbumTrackParams && this.$$newTrackClick(this.myAlbumTrackParams)
      window.open(
        `/v/selfphoto/my-album?orderId=${this.order.orderId}&cmd=share&sharetype=0&naviType=4`
      )
    }
  },
  computed: {
    takePhotoReserveDateTime() {
      return this.order.reserveRecord
        ? this.order.reserveRecord.reserveDate +
            ' ' +
            this.order.reserveRecord.reserveTime
        : ''
    },
    needShowReserveDateTimeBtn() {
      return (
        CLOUD_PHOTO_STATE_ENUM.STEP2_RESERVE_STAGE ==
          this.currCloudPhotoState && !this.order.reserveRecord
      )
    },
    needShowModifyReserveDateTimeBtn() {
      return (
        CLOUD_PHOTO_STATE_ENUM.STEP2_RESERVE_STAGE ==
          this.currCloudPhotoState && this.order.reserveRecord
      )
    },
    needShowMyAlbumBtn() {
      return (
        CLOUD_PHOTO_STATE_ENUM.STEP2_RESERVE_STAGE < this.currCloudPhotoState
      )
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.cloud-photo-info {
  margin: rem(20px) rem(24px) rem(20px);
  padding: rem(30px) rem(24px) rem(32px) rem(24px);
  border-radius: rem(16px);
  background: #fff;

  .cloud-photo-steps-title {
    font-size: rem(30px);
  }
  .steps-section {
    padding-top: rem(32px);
    padding-bottom: rem(24px);
    .step-item {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      // align-items: center;
      .step-index-section {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .step-index-icon-img {
          width: rem(48px);
          height: rem(48px);
        }

        .step-index {
          width: rem(48px);
          height: rem(48px);
          border-radius: rem(24px);
          font-size: rem(30px);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .step-index-completed {
          color: #ff5900;
          background: none;
          border: rem(2px) solid #ff5900;
        }
        .step-index-on-stage {
          color: #fff;
          background: #ff5900;
          border: none;
        }

        .step-index-not-start {
          color: #999999;
          background: none;
          border: 1px solid #cccccc;
        }

        .step-stage-v-line {
          width: 1px;
          height: rem(48px);
        }

        .step-index-vline-completed {
          background: #ff5900;
        }
        .step-index-vline-on-stage {
          background: #e0e0e0;
        }
        .step-index-vline-not-start {
          background: #e0e0e0;
        }
      }

      .step-info-section {
        margin-top: rem(5px);
        margin-left: rem(24px);
        .step-title {
          line-height: rem(40px);
          font-size: rem(28px);
        }
        .step-title-completed {
          color: #666666;
        }

        .step-title-on-stage {
          color: #121212;
          font-weight: 500;
        }
        .step-title-not-start {
          color: #666666;
        }

        .step-tips-line {
          font-size: rem(26px);
          line-height: rem(40px);
          height: rem(50px);
        }

        .step-tips-completed {
          color: #bebebe;
        }
        .step-tips-on-stage {
          color: #ff8800;
        }
      }
    }
  }

  .btn-action {
    display: flex;
    width: 100%;
    text-align: center;

    .btn-large {
      flex: 1;
      color: #fff;
      height: rem(80px);
      line-height: rem(80px);
      background: linear-gradient(90deg, #ff8800, #ff5900);
      border-radius: rem(100px);
      font-size: rem(28px);
      font-weight: 500;
    }
  }
}
</style>
